import { configureStore } from '@reduxjs/toolkit'
import loadingReducer from './loading/index'
import userReducer from './user/index'
const store = configureStore({
    reducer: {
        loading: loadingReducer,
        user: userReducer
    },
})
export default store